module.exports = __webpack_public_path__ + "img/factory_stand.424a7aeb.jpg";